import { render, staticRenderFns } from "./listTwo.vue?vue&type=template&id=968c943e&scoped=true"
import script from "./listTwo.vue?vue&type=script&lang=js"
export * from "./listTwo.vue?vue&type=script&lang=js"
import style0 from "./listTwo.vue?vue&type=style&index=0&id=968c943e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968c943e",
  null
  
)

export default component.exports